var exports = {
  "vd": "selectPanel__3IAtAv",
};

module.exports = exports;
